// nuolino-admin/src/lib/query-client.ts
// Configuração do React Query. T4.2.2 e T4.4 ampliam (auth-aware defaults).

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: { retry: 0 },
  },
});
